import React from "react";
import Card from "../Card";
import styles from "./TokenWallet.module.sass";
import RichViewer from "../HTMLeditor/Draft.viewer";
import nft_product from "../../i11/Nft_Product";
import TemplateModal from "../../screens/NewProduct/TemplateModal";

import { useUser } from "../../context";
import { UseDisclosure } from "../../hooks/use-disclosure";

const TokenWal = ({ data }) => {
	const { locale } = useUser();

	const { isOpen, onOpen, onClose } = UseDisclosure();
	return (
		<Card title={nft_product[locale].product} classTitle="title-green">
			{data && (
				<div className={styles.container}>
					<div className={styles.top}>
						<div className={styles.img}>
							<img src={data.image} alt={data.name} />
						</div>
						<Top data={data} />
					</div>
					<br />
					<div className={styles.h12345}>
						<h4>{nft_product[locale].details}</h4>
						<br />
						<div className={styles.subText}>
							{nft_product[locale].o_category}
						</div>
						<div className={styles.subVal}>
							{data.category?.title}
						</div>
						<div className={styles.subText}>
							{nft_product[locale].o_collection}
						</div>
						<div className={styles.subVal}>
							{data.nftCollection?.name}
						</div>
						<div className={styles.subText}>
							{nft_product[locale].token_type}
						</div>
						<div className={styles.subVal}>{data.tokenType}</div>
						<div className={styles.subText}>
							{nft_product[locale].description}
						</div>
						<div className={styles.subVal}>{data.description}</div>
						<button
							className="button"
							type="button"
							onClick={onOpen}
						>
							{nft_product[locale].long_desc}
						</button>
						<br />

						<div className={styles.subText}>
							{nft_product[locale].royalty_percent}
						</div>
						<div className={styles.subVal}>{data.royalties}%</div>
						<div className={styles.subText}>
							{nft_product[locale].type}
						</div>
						<div className={styles.subVal}>
							{data.type === "SINGLE_EDITION" && "Unique"}
						</div>
						<div className={styles.subVal}>
							{data.type === "LIMITED_EDITION" && "Standart"}
						</div>
						<div className={styles.subVal}>
							{data.type === "AUCTION_EDITION" && "Auction"}
						</div>
						<div className={styles.subText}>
							{nft_product[locale].origin_l_price}
						</div>
						<div className={styles.subVal}>
							{data.tradeInSize ? data.price : "N/A"}
						</div>
						<br />

						{data.tokenType === "PHYSICAL_TOKEN" && (
							<>
								<div className={styles.subText}>
									{nft_product[locale].product} ID:
									<div>{data.skuNumber}</div>
								</div>
								<div className={styles.subText}>
									{nft_product[locale].w_p_up}:
									<div>
										{
											data.shippingInfo?.pickupAddressID
												?.AddressLineString
										}
									</div>
								</div>
								<div className={styles.subText}>
									{nft_product[locale].sale_type}:
									<div>
										{data.type === "AUCTION_EDITION"
											? "Auction"
											: "SALE"}
									</div>
								</div>
								<div className={styles.subText}>
									{nft_product[locale].dimensions}
								</div>
								<div style={{ display: "flex", gap: "5px" }}>
									<div className={styles.hw}>
										{"Height: "}
									</div>
									<div>{data.shippingInfo?.height}</div>
									<div className={styles.hw}>{"Width: "}</div>
									<div>{data.shippingInfo?.width}</div>
									<div className={styles.hw}>
										{"Weight: "}
									</div>
									<div>{data.shippingInfo?.weight}</div>
									<div className={styles.hw}>
										{"Length: "}
									</div>
									<div>{data.shippingInfo?.length}</div>
								</div>
							</>
						)}
					</div>
				</div>
			)}
			<TemplateModal visible={isOpen} onClose={onClose}>
				{isOpen && <RichViewer data={data.nftTemplate?.drawHtml} />}
			</TemplateModal>
		</Card>
	);
};

const Top = ({ data }) => {
	const { locale } = useUser();
	return (
		<div className={styles.topLeft}>
			<div>{nft_product[locale].name}</div>
			<div className="title">{data.name}</div>

			<div className={styles.topRow}>
				<div>
					<div className={styles.statistic}>
						<div className={styles.opacity}>
							{nft_product[locale].token_id}
						</div>
						<div className={styles.opacity}></div>
						<div>{data.smartContract}</div>
						<div>{/* - - - - - */}</div>
					</div>
					<div className={styles.statistic}>
						<div className={styles.opacity}>
							{nft_product[locale].serial}
						</div>
						<div className={styles.opacity}>{/* Owners */}</div>
						<div>
							<div className={styles.type}>{data.tokenId}</div>
							{/* Type[data.type] */}
						</div>
						<div>{/* {data.countNFTs} */}</div>
					</div>
				</div>
				<div>
					<div className={styles.statistic}>
						<div className={styles.opacity}>
							{nft_product[locale].origin}
						</div>
						<div className={styles.opacity}></div>
						<div>
							{data.tradeInSize ? "Trade-in" : "Direct Mint"}
						</div>
						<div>{/* - - - - - */}</div>
					</div>
					<div className={styles.statistic}>
						<div className={styles.opacity}>
							{nft_product[locale].c_status}
						</div>
						<div className={styles.opacity}>{/* Owners */}</div>
						<div>
							{
								nft_product[locale][
									data.isOnSale
										? "listed"
										: data.rafflesSize
										? "prize"
										: "na"
								]
							}
						</div>
						<div>{/* {data.countNFTs} */}</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default TokenWal;
